import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import rootReducer, { AppState } from "./rootReducer";

// imported in App.tsx
export const store = configureStore({ reducer: rootReducer });

// typed hooks. use these instead of the default ones
export const useAppDispatch = useDispatch<typeof store.dispatch>;
export const useAppSelector = <T>(f: (state: AppState) => T) =>
  useSelector<AppState, T>(f);
